module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAAEJJREFUKBVjYBgy4P///w1ATC5owOpRoGnkGIrdMJgNJBqK3zASDSXOMCINJc0wAoaSZxgOQykzDM1Q6hgGM3TAaACmORcAO+7zHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/white-arrow-down.png
// module id = yveC
// module chunks = 0